import { addDays, eachDayOfInterval, endOfMonth, endOfWeek, isToday, startOfMonth, startOfWeek, } from "date-fns";
import { assign, createMachine } from "xstate";
import { useMachine } from "xstate-svelte";
const loadHabits = () => { var _a; return ((_a = JSON.parse(localStorage.getItem("habits"))) !== null && _a !== void 0 ? _a : []); };
const saveHabits = (habits) => localStorage.setItem("habits", JSON.stringify(habits));
const buildContext = (date, habits) => ({
    currentDate: date,
    currentMonth: eachDayOfInterval({
        start: startOfWeek(startOfMonth(date), { weekStartsOn: 1 }),
        end: endOfWeek(endOfMonth(date), { weekStartsOn: 1 }),
    }),
    habits,
});
export const habitMachine = createMachine({
    initial: "idle",
    context: buildContext(new Date(), loadHabits()),
    states: {
        idle: {
            on: {
                NAVIGATE: {
                    actions: assign((ctx, evt) => {
                        switch (evt.direction) {
                            case "BACK":
                                return buildContext(addDays(ctx.currentMonth[0], -1), ctx.habits);
                            case "HOME":
                                return buildContext(new Date(), ctx.habits);
                            case "FORWARD":
                                return buildContext(addDays(ctx.currentMonth[ctx.currentMonth.length - 1], 1), ctx.habits);
                        }
                    }),
                    cond: (ctx, evt) => !(evt.direction === "HOME" && isToday(ctx.currentDate)),
                },
                EDIT: "edit",
                RESET: {
                    actions: [
                        assign(buildContext(new Date(), [])),
                        () => localStorage.clear(),
                    ],
                },
            },
        },
        edit: {
            on: {
                CANCEL_EDIT: "idle",
                ADD_HABIT: {
                    target: "idle",
                    actions: [
                        assign({
                            habits: (ctx, evt) => ctx.habits.concat([evt.habit]),
                        }),
                        (ctx) => saveHabits(ctx.habits),
                    ],
                },
            },
        },
    },
});
export const { state, send } = useMachine(habitMachine);
